import React from 'react';
import { Send, MessageCircle, Mail, Facebook } from 'lucide-react';
import MagneticButton from './MagneticButton';
import { contactInfo } from '../mock';
import '../styles/Home.css';
import '../styles/EliteEffects.css';

const CTA = () => {
  const handleTelegramClick = () => {
    window.open('https://t.me/srwebstudio', '_blank');
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/48452688251', '_blank');
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:webstudiosr4@gmail.com';
  };

  const handleFacebookClick = () => {
    window.open(contactInfo.facebook, '_blank');
  };

  return (
    <section className="cta section-padding">
      <div className="container">
        <div className="cta-content ultra-smooth">
          <h2 className="hero-medium">Chcesz taki sklep?</h2>
          <p className="body-large">Skontaktuj się ze mną, aby omówić Twój projekt</p>
          
          {/* Main Telegram CTA */}
          <div className="cta-main-button">
            <MagneticButton 
              className="btn-primary btn-telegram glow-breathe" 
              onClick={handleTelegramClick}
            >
              <Send size={20} />
              Napisz na Telegram
            </MagneticButton>
            <span className="contact-handle">@srwebstudio</span>
          </div>

          {/* Alternative contact methods */}
          <div className="cta-alternative">
            <p className="body-small">Lub skontaktuj się inaczej:</p>
            <div className="cta-contact-buttons">
              <MagneticButton 
                className="contact-btn ultra-smooth" 
                onClick={handleWhatsAppClick}
              >
                <MessageCircle size={18} />
                <span>WhatsApp</span>
              </MagneticButton>
              <MagneticButton 
                className="contact-btn ultra-smooth" 
                onClick={handleFacebookClick}
              >
                <Facebook size={18} />
                <span>Facebook</span>
              </MagneticButton>
              <MagneticButton 
                className="contact-btn ultra-smooth" 
                onClick={handleEmailClick}
              >
                <Mail size={18} />
                <span>Email</span>
              </MagneticButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
